// extracted by mini-css-extract-plugin
export default {"container":"WM-z","disabled":"XM-z","bgBlack":"YM-z","content":"ZM-z","countdown":"_M-z","topCaption":"aN-z","topHeading":"bN-z","heading":"cN-z","copy":"dN-z"};